import React, { useState } from "react";
import { Link as RouterLink, useNavigate, useLocation } from "react-router-dom";
import { useApi } from "../Api/ApiContext";
import { useAsyncFn } from "react-use";
import {
  Col,
  Form,
  FormGroup,
  FormFeedback,
  Row,
  Spinner,
  Button,
  Alert,
} from "reactstrap";
import { useForm } from "react-hook-form";
import Input from "../component/Input";

const LoginForm = () => {
  const { logIn } = useApi();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    values,
  } = useForm();

  const [{ loading, error, value }, LogIn] = useAsyncFn((credentials) =>
    logIn(credentials)
  );

  const onSubmit = (data) => {
    LogIn({ ...data });
  };

  if (loading) {
    return (
      <Row>
        <Col lg={6} className={"mx-auto text-center"}>
          <Spinner color={"danger"} />
        </Col>
      </Row>
    );
  }

  if (!loading && !error && value) {
    navigate("/admin");
  }

  return (
    <div className={"my-3 my-lg-3"}>
      <Row>
        <Col lg={6} className={"mx-auto"}>
          <h1 className={"fs-4"}>Connectez-vous</h1>
        </Col>
      </Row>

      {error && (
        <Row>
          <Col lg={6} className={"mx-auto"}>
            <Alert color={"danger"}>
              Identifiant et/ou mot de passe incorrecte.{" "}
            </Alert>
          </Col>
        </Row>
      )}
      <Row>
        <Col lg={6} className={"mx-auto"}>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <FormGroup className={"position-relative"}>
              <label htmlFor="username" className={"form-label"}>
                Adresse email
              </label>
              <Input
                id={"username"}
                className={
                  errors.username ? "is-invalid form-control" : "form-control"
                }
                type={"email"}
                value={values?.username}
                name={"username"}
                {...register("username", {
                  required: "Ce champ est obligatoire.",
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: "Le format de l'adresse e-mail n'est pas valide.",
                  },
                })}
              />
              {errors.username && (
                <FormFeedback>{errors.username.message}</FormFeedback>
              )}
            </FormGroup>
            <FormGroup>
              <label htmlFor="password" className={"form-label"}>
                Mot de passe
              </label>
              <Input
                className={
                  errors.password ? "is-invalid form-control" : "form-control"
                }
                id={"password"}
                type={"password"}
                name={"password"}
                {...register("password", {
                  required: "Ce champ est obligatoire.",
                })}
                value={values?.password}
              />
              {errors.password && (
                <FormFeedback>{errors.password.message}</FormFeedback>
              )}
            </FormGroup>
            <Row>
              <Col className={"mx-auto"}>
                Mot de passe oublié ?{" "}
                <RouterLink
                  to={"/auth/check-email"}
                  state={{ backPath: "/auth/login" }}
                >
                  Réinitialiser votre mot de passe
                </RouterLink>
              </Col>
            </Row>
            <Row>
              <Col className={"mx-auto"}>
                Vous n'avez pas de compte ?{" "}
                <RouterLink
                  to={"/auth/sign-up"}
                  state={{ backPath: "/auth/login" }}
                >
                  Créer un compte
                </RouterLink>
              </Col>
            </Row>
            <FormGroup
              row
              className={"mt-2 justify-content-sm-end justify-content-around"}
            >
              <Col xs={12} sm={3}>
                <Button className={"w-100"} color={"primary"} type={"submit"}>
                  Connexion
                </Button>
              </Col>
            </FormGroup>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default LoginForm;
